import React from 'react';

import './Loader.css';
import { Spinner } from './Spinner';

function Loader({ text }) {
  return (
      <div className="loader">
        <div className="loader_content">
          <Spinner width="6rem" height="6rem" />
          {text && <p>{text}</p>}
      </div>
    </div>
  );
}

export default Loader;
